var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',{staticClass:"text-center"},[_vm._v("Estamos trabajando para voz.")]),_c('v-img',{staticClass:"mx-auto",attrs:{"width":"600","src":require("@/assets/img/sections/working.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }